import { LocationDto } from "src/dtos/location/locationDto";

export interface MST1110_R01Dto extends LocationDto {
	
}

export const defaultMST1110_R01Dto: MST1110_R01Dto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	locationCd: '',
	locationNm: '',
	logicCenter: '',
	logicCenterNm: '',
	warehouseCd: '',
	warehouseNm: '',
	remark: '',

	inserted: false,
	isModified: false,
}